import React from "react";

export default function RefundPage() {
  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-14">
      <div className="mb-10">
        <div className="kyro-overline">Policy</div>
        <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter mt-3">Cancellation & Refunds</h1>
        <p className="text-xs text-kyro-faint mt-3">Last updated on 20-07-2026 19:07:33</p>
      </div>

      <article className="kyro-card p-6 md:p-10 space-y-5 text-[15px] leading-relaxed text-kyro-mute">
        <p>
          <strong className="text-kyro-ink">BABA MEDIA</strong> believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:
        </p>
        <ul className="list-disc pl-6 space-y-4">
          <li>Cancellations will be considered only if the request is made immediately after placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.</li>
          <li><strong className="text-kyro-ink">BABA MEDIA</strong> does not accept cancellation requests for perishable items like flowers, eatables etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.</li>
          <li>In case of receipt of damaged or defective items please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within <strong className="text-kyro-ink">the same day</strong> of receipt of the products.</li>
          <li>In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within <strong className="text-kyro-ink">the same day</strong> of receiving the product. The Customer Service Team, after looking into your complaint, will take an appropriate decision.</li>
          <li>In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them.</li>
          <li>In case of any refunds approved by <strong className="text-kyro-ink">BABA MEDIA</strong>, it will take <strong className="text-kyro-ink">16–30 days</strong> for the refund to be processed to the end customer.</li>
        </ul>

        <p className="pt-3">
          To raise a cancellation, refund or complaint, please email us at{" "}
          <a href="mailto:ankitsharmap05@gmail.com" className="text-[#FF4433] hover:underline">ankitsharmap05@gmail.com</a>{" "}
          or call{" "}
          <a href="tel:+919924731282" className="text-[#FF4433] hover:underline">+91 99247 31282</a>{" "}
          with your order ID.
        </p>
      </article>
    </div>
  );
}
